define([
	"dojo/_base/array",
	"dojo/_base/declare",
	"csi/action/FreezeController",
	"csi/comm/PostRequest",
	"csi/locale",
	"csi/widget/MessageDialog",
	"csi/xml"
], function(array,declare,FreezeController,PostRequest,locale,MessageDialog,xml) {

	var BUTTON_FREEZE_ANYWAY = "FREEZE_ANYWAY";
	
	return declare(FreezeController, {
		/** @property {boolean} isNodeFrozen - Will be true when the node is frozen and false otherwise */
		isNodeFrozen: false,

		/**
		 * @override
		 * This will query the frozen status of the current node on the database to ensure we have the latest frozen value
		 */
		onPreActionDeferreds: function(dfds) {
			const request = new PostRequest("Sourcing", "ValidatePurchasedOrderFrozenStatus");
			request.addParameter(xml.PROP_URL, this.m_urlNode);

			const newDfd = request.go().then((response) => this.isAlreadyFrozen = response.getReturnValue());
			dfds.push(newDfd);
		},

		preProcess: function() {
			var shipmentTerms = this.getNode();
			var btn = [MessageDialog.BUTTON_FREEZE + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL]; 
			if (this.m_bToggle) {
				FreezeController.prototype.preProcess.call(this);
			} else {
				if(!this.isAlreadyFrozen) {
					var msg = locale.resource("CONFIRM_FREEZE_SHIPMENT");
					var t = locale.resource("CONFIRM_FREEZE_SHIPMENT_TITLE");
					var shipments =this.widget.getCache().getChildren(shipmentTerms, "Shipments", true);
					if (!shipments || array.some(shipments, function(s) { return s.Quantity <= 0; })) {
						msg = locale.resource("WARNING_SHIPMENT_QTY_ZERO");
						btn = [BUTTON_FREEZE_ANYWAY + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL];
					}

					this.confirmAction({message:msg, buttons:btn, title:t});
				} else{
					const msg = locale.resource("ERROR_SHIPMENT_ALREADY_FROZEN");
					const t = locale.resource("REFRESH_BROWSER_TITLE");
					const btn = [MessageDialog.BUTTON_REFRESH + MessageDialog.BUTTON_PRIMARY, MessageDialog.BUTTON_CANCEL];
					this.confirmAction({message:msg, buttons:btn, title:t});
				}
			}
		},

		/**
		 * @override
		 * Updated to only call the writer when the current frozen status is different from the toggle state.
		 */
		_toCallWriter: function() {
			if(this.m_bToggle === this.isAlreadyFrozen) {
				this.m_writer.freezeNode(this.m_urlNode, !this.m_bToggle);
			}
		},

		onConfirm: function(/*String*/key) {
			if ((key == MessageDialog.BUTTON_FREEZE) || (key == BUTTON_FREEZE_ANYWAY)) {
				FreezeController.prototype.preProcess.call(this);
			} else if (key == MessageDialog.BUTTON_REFRESH) {
				this.process();
			} else {
				this.postProcess();
			}
		}
	});
});